

import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
   
    <header
      className="absolute top-0 left-0 right-0 z-50"
      style={{ background: 'linear-gradient(180deg, #1C1C1C 0%, rgba(28, 28, 28, 0) 100%)' }}
    >
      <div className="px-6 lg:px-[100px]">
        <div className="flex items-center justify-between py-6">
          {/* Logo */}
          <Link to="/" className="flex items-center">
              {/* Replace with your actual logo */}
             <img src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763644542/AEX_1_phqwfw.png" alt="Logo" width={128} height={44} className="object-cover h-[44px] w-full" />
          </Link>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center text-[15px] gap-8">
            <Link
              to="/about"
              className={`font-medium transition-colors duration-300 hover:text-[#0875D4] ${location.pathname === '/about' ? 'text-white' : 'text-[#FFFFFFB2]'}`}
            >
              About
            </Link>
            <Link
              to="/services"
              className={`font-medium transition-colors duration-300 hover:text-[#0875D4] ${location.pathname === '/services' ? 'text-white' : 'text-[#FFFFFFB2]'}`}
            >
              Solutions
            </Link>
            <Link
              to="/oem-partnership"
              className={`font-medium transition-colors duration-300 hover:text-[#0875D4] ${location.pathname === '/oem-partnership' ? 'text-white' : 'text-[#FFFFFFB2]'}`}
            >
              OEM Partnerships
            </Link>
            <Link
              to="/hse-policy"
              className={`font-medium transition-colors duration-300 hover:text-[#0875D4] ${location.pathname === '/hse-policy' ? 'text-white' : 'text-[#FFFFFFB2]'}`}
            >
              HSE Policy
            </Link>
            <Link
              to="/csr"
              className={`font-medium transition-colors duration-300 hover:text-[#0875D4] ${location.pathname === '/csr' ? 'text-white' : 'text-[#FFFFFFB2]'}`}
            >
              CSR
            </Link>
            <Link
              to="/careers"
              className={`font-medium transition-colors duration-300 hover:text-[#0875D4] ${location.pathname === '/careers' ? 'text-white' : 'text-[#FFFFFFB2]'}`}
            >
              Careers
            </Link>
            <Link
              to="/contact"
              className={`font-medium transition-colors duration-300 hover:text-[#0875D4] ${location.pathname === '/contact' ? 'text-white' : 'text-[#FFFFFFB2]'}`}
            >
              Contact
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white/90 hover:bg-white/10 cursor-pointer"
            >
              <i
                className={`ri-${mobileMenuOpen ? "close" : "menu"}-line text-xl text-white`}
              ></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="lg:hidden">
          <div className="px-2 pt-2 pb-3 space-y-0 sm:px-3 bg-white border-t">
            <Link 
              to="/about" 
              className={`block px-3 py-3 text-center border-b border-gray-200 text-base font-medium transition-colors cursor-pointer ${
                location.pathname === "/about"
                  ? "bg-teal-100 text-teal-700"
                  : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </Link>
            <Link 
              to="/services" 
              className={`block px-3 py-3 text-center border-b border-gray-200 text-base font-medium transition-colors cursor-pointer ${
                location.pathname === "/services"
                  ? "bg-teal-100 text-teal-700"
                  : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Solutions
            </Link>
            <Link 
              to="/oem-partnership" 
              className={`block px-3 py-3 text-center border-b border-gray-200 text-base font-medium transition-colors cursor-pointer ${
                location.pathname === "/oem-partnership"
                  ? "bg-teal-100 text-teal-700"
                  : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              OEM Partnerships
            </Link>
            <Link 
              to="/hse-policy" 
              className={`block px-3 py-3 text-center border-b border-gray-200 text-base font-medium transition-colors cursor-pointer ${
                location.pathname === "/hse-policy"
                  ? "bg-teal-100 text-teal-700"
                  : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              HSE Policy
            </Link>
            <Link 
              to="/csr" 
              className={`block px-3 py-3 text-center border-b border-gray-200 text-base font-medium transition-colors cursor-pointer ${
                location.pathname === "/csr"
                  ? "bg-teal-100 text-teal-700"
                  : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              CSR
            </Link>
            <Link 
              to="/careers" 
              className={`block px-3 py-3 text-center border-b border-gray-200 text-base font-medium transition-colors cursor-pointer ${
                location.pathname === "/careers"
                  ? "bg-teal-100 text-teal-700"
                  : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Careers
            </Link>
            <Link 
              to="/contact" 
              className={`block px-3 py-3 text-center border-b border-gray-200 text-base font-medium transition-colors cursor-pointer ${
                location.pathname === "/contact"
                  ? "bg-teal-100 text-teal-700"
                  : "text-gray-600 hover:text-teal-600 hover:bg-gray-50"
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}